enum WorkspaceProjectCarbonAndLandRightsAgreementType {
  'Land lease agreement' = 'Land lease agreement',
  'Benefit sharing agreement' = 'Benefit sharing agreement',
  'Project area management agreement' = 'Project area management agreement',
  'Carbon project development agreement' = 'Carbon project development agreement',
  'Carbon rights transfer agreement' = 'Carbon rights transfer agreement',
  'Payment for ecosystem services agreement' = 'Payment for ecosystem services agreement',
}

export default WorkspaceProjectCarbonAndLandRightsAgreementType
